import logger from '../shares/lib/logger';
import getCurrentGameSelected from '../shares/lib/currentGameSelected';
import { generateNonce } from '../shares/lib/generateNonce';
import { showError, hideLoader } from '../shares/lib/otpUtils';

const playFromCallback = async (
  urlCallbackFn:
    | ((
        nonce: string,
        metadata?: { gameId: string },
      ) => void | Promise<{ url: string; nonce: string } | void>)
    | null
    | undefined,
): Promise<string | null> => {
  if (!urlCallbackFn || typeof urlCallbackFn !== 'function') {
    return null;
  }

  try {
    const generatedNonce = generateNonce();
    const { currentGameId } = getCurrentGameSelected();

    const callbackResult = await urlCallbackFn(generatedNonce, {
      gameId: currentGameId,
    });

    if (
      callbackResult &&
      typeof callbackResult === 'object' &&
      'url' in callbackResult &&
      'nonce' in callbackResult
    ) {
      if (callbackResult.nonce !== generatedNonce) {
        const errorMsg = 'Nonce mismatch: callback returned invalid nonce';
        logger.error(errorMsg);
        hideLoader();
        showError(errorMsg);
        throw new Error(errorMsg);
      }

      const url = callbackResult.url;

      if (!url || typeof url !== 'string') {
        const errorMsg = 'Invalid URL: URL must be a non-empty string';
        logger.error(errorMsg);
        hideLoader();
        showError(errorMsg);
        throw new Error(errorMsg);
      }

      if (url.trim() === '') {
        const errorMsg = 'Invalid URL: URL cannot be empty';
        logger.error(errorMsg);
        hideLoader();
        showError(errorMsg);
        throw new Error(errorMsg);
      }

      try {
        new URL(url);
      } catch (error) {
        const errorMsg = `Invalid URL format: ${url}`;
        logger.error('Invalid URL format', { url, error });
        hideLoader();
        showError(errorMsg, error);
        throw new Error(errorMsg);
      }

      logger.info('Using URL from urlCallbackFn callback', { url });
      return url;
    }

    return null;
  } catch (error) {
    logger.error('Error in playFromCallback', { error });
    throw error;
  }
};

export default playFromCallback;
